export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20abstract%20composition%20flowing%20ribbons%20of%20coral%20red%20and%20warm%20gold%20against%20deep%20dark%20background%20with%20scattered%20sparkling%20particles%20resembling%20digital%20data%20streams%20modern%20editorial%20aesthetic%20cinematic%20moody%20lighting%20with%20warm%20glow%20representing%20trending%20news%20and%20viral%20content%20high%20contrast%20artistic%20style&width=1600&height=1000&seq=hero-bg-2026-h1&orientation=landscape"
          alt="黑料大赛 - 最火八卦热度排行榜封面背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tags */}
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-6 flex-wrap">
              <span className="px-4 py-1.5 rounded-full text-xs font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 whitespace-nowrap">
                <i className="ri-fire-fill mr-1.5"></i>实时更新
              </span>
              <span className="px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 whitespace-nowrap">
                <i className="ri-flashlight-fill mr-1.5"></i>全网热度
              </span>
            </div>

            {/* H1 */}
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              黑料大赛
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl text-background-50/80 font-body font-light mt-2">
                最火八卦热度排行榜
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-accent-400 font-heading mb-6">
              吃瓜第一线，热度早知道
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-background-50/75 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              黑料大赛专注聚合全网最热八卦事件与网红黑料热度排名，每日实时追踪热搜动态，覆盖明星恋情、网红翻车、综艺争议、品牌塌房等多维度爆料内容。无论你是资深吃瓜群众还是刚刚入坑的新朋友，这里都能第一时间掌握最新最全的热门爆料动态，让每一次刷新都充满惊喜。
            </p>

            {/* Stats */}
            <div className="flex items-center justify-center lg:justify-start gap-8 md:gap-12 mb-8 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">2000+</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">覆盖热点事件</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">50+</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">日均更新条数</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">24h</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">全天候追踪</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex items-center justify-center lg:justify-start gap-4 flex-wrap">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看热搜榜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm border border-background-50/30 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                立即投稿爆料
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20abstract%20editorial%20composition%20warm%20coral%20red%20and%20golden%20amber%20gradient%20flowing%20through%20dark%20canvas%20with%20glowing%20particles%20representing%20trending%20content%20and%20viral%20social%20media%20energy%20cinematic%20atmosphere%20professional%20artistic%20quality&width=800&height=600&seq=hero-visual-2026-h2&orientation=landscape"
                alt="黑料大赛热度排行主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="flex items-center gap-3">
                  <span className="w-3 h-3 rounded-full bg-accent-500 animate-pulse"></span>
                  <span className="text-background-50 text-sm font-medium">热搜实时更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}